import { debounce } from 'lodash';
import { scrollTo } from 'utils';

export default {
	data () {
		return {
			height: null,
			toggle: false,
			showButton: null,
			wrapElement: null,
			totalHeight: null,
			slotElements: null,
		};
	},
	props: {
		anchor: {
			type: String,
			default: null,
		},
		buttonTextMore: {
			type: String,
			default: 'Läs mer',
		},
		buttonTextLess: {
			type: String,
			default: 'Läs mindre',
		},
		wrapperHeight: {
			type: Number,
			default: 700,
		},
	},
	created () {
		this.debouncer = debounce(this.debouncer, 500);
	},
	mounted () {
		this.setHeight(this.slotElements);
	},
	methods: {
		changeHandler () {
			this.toggle = ! this.toggle;
			if (! this.toggle && this.anchor) {
				scrollTo('#' + this.anchor);
			}
		},
		debouncer: function () {
			this.setHeight(this.slotElements);
		},
		setHeight (slotElements) {
			if (slotElements) {
				let height = 0;
				slotElements.forEach(node => {
					if (node.elm.clientHeight) {
						height += node.elm.clientHeight;
					}
				});
				if (height > this.wrapperHeight) {
					this.showButton = true;
				} else {
					this.showButton = false;
				}
			}
		},
	},
	computed: {
		editButtonText () {
			return this.toggle ? this.buttonTextLess : this.buttonTextMore;
		},
		class () {
			return this.toggle ? 'expanded' : null;
		},
	},
	watch: {
		slotElements: {
			handler: function () {
				this.debouncer.call(this);
			},
			deep: true
		},
		toggle (to) {
			if (to) {
				this.height = 'auto';
			} else {
				this.height = this.wrapperHeight + 'px';
			}
		},
	},
	render (c) {
		let button = c('button',
			{
				'class': [
					'read-more-toggle',
					{
						'show-button': this.showButton,
					}
				],
				'on': {
					'click': this.changeHandler,
				},
				'ref': 'button',
			}
		);

		button.text = this.editButtonText;

		this.slotElements = this.$slots.default;

		return c('div',
			{
				'class': [
					this.class, 'read-more-wrapper',
					{ 'show-button': this.showButton, }
				],
				attrs: { id: this.anchor },
				style: {
					maxHeight: this.wrapperHeight + 'px',
				}
			},
			[
				this.$slots.default,
				c('div',
					{
						'class': [
							'read-more-footer',
							{
								hidden: ! this.showButton,
								open: this.toggle,
							}
						],
					},
					[
						button,
					],
				),
			],
		);
	},
};